import { UUID } from '../uuid.model';

export class UserDTO {
  constructor(
    public readonly activated: boolean,
    public readonly authorities: string[],
    public readonly createdBy: string,
    public readonly createdDate: any,
    public readonly designation: string,
    public readonly editable: boolean,
    public readonly email: string,
    public readonly firstName: string,
    public readonly id: UUID,
    public readonly idsSites: UUID[],
    public readonly idsStructures: UUID[],
    public readonly imageUrl: string,
    public readonly langKey: string,
    public readonly lastModifiedBy: string,
    public readonly lastModifiedDate: any,
    public readonly lastName: string,
    public readonly login: string,
    public readonly mailsActivated: boolean,
    public readonly physique: boolean,
    public readonly raisonSociale: string,
    public readonly restrictionSite: boolean,
    public readonly typesPrestation: string[]
  ) {}

  public static hydrate(obj: UserDTO): UserDTO {
    return new UserDTO(
      obj.activated,
      obj.authorities,
      obj.createdBy,
      obj.createdDate,
      obj.designation,
      obj.editable,
      obj.email,
      obj.firstName,
      obj.id,
      obj.idsSites,
      obj.idsStructures,
      obj.imageUrl,
      obj.langKey,
      obj.lastModifiedBy,
      obj.lastModifiedDate,
      obj.lastName,
      obj.login,
      obj.mailsActivated,
      obj.physique,
      obj.raisonSociale,
      obj.restrictionSite,
      obj.typesPrestation
    );
  }
}
